import HeroBlock from "./HeroBlock.vue"

export default function install(Vue) {
  Vue.component(HeroBlock.name, HeroBlock)
}
